import { useState } from "react";

const LS_KEY = "table_page_size";
const DEFAULT = 12;
const MIN = 5;
const MAX = 100;

export default function usePageSize() {
    const [pageSize, setPageSizeState] = useState<number>(() => {
        const stored = localStorage.getItem(LS_KEY);
        const parsed = stored ? parseInt(stored, 10) : NaN;
        return !isNaN(parsed) && parsed >= MIN && parsed <= MAX ? parsed : DEFAULT;
    });

    const setPageSize = (size: number) => {
        const clamped = Math.max(MIN, Math.min(MAX, size));
        localStorage.setItem(LS_KEY, String(clamped));
        setPageSizeState(clamped);
    };

    return { pageSize, setPageSize };
}
